import { baseAPI } from '~shared/api/base-api';

interface ReportingSessionStudentsEnrollmentsParams {
  format?: string;
  sessionId: string;
  classKeywords?: string;
}

export const reportingSessionStudentsEnrollmentsAPI = async (
  params: ReportingSessionStudentsEnrollmentsParams,
) => {
  const response = await baseAPI.get<string>(
    'reporting/session-students-enrollments',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};
